import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=e64cc97e&scoped=true&"
import script from "./EditorToolbar.vue?vue&type=script&lang=js&"
export * from "./EditorToolbar.vue?vue&type=script&lang=js&"
import style0 from "./EditorToolbar.vue?vue&type=style&index=0&id=e64cc97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64cc97e",
  null
  
)

export default component.exports